import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

const SPG = lazy(() => import('./apps/spg/App'))
const ACT = lazy(() => import('./apps/act/App'))

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/spg" replace />} />
        <Route path="/spg/*" element={<Suspense fallback={null}><SPG /></Suspense>} />
        <Route path="/act/*" element={<Suspense fallback={null}><ACT /></Suspense>} />
      </Routes>
    </BrowserRouter>
  )
}
